import React, { useState } from "react";
import Collapsible from "react-collapsible";
import sanitizeHtml from "sanitize-html";
import FaqStyles from "./FaqStyles";

const FaqComponent = ({ title, faqs }) => {
  const [currentOpened, setCurrentOpened] = useState(null);
  const handleClick = (id) => {
    setCurrentOpened(currentOpened === id ? null : id);
  };
  const sanitizeSettings = {
    allowedTags: ["p", "br", "u", "a"],
  };

  return (
    <FaqStyles className="faqs">
      <div className="container">
        <h3>{title}</h3>
        {faqs &&
          faqs.map((term, index) => (
            <div className="row" key={index}>
              <Collapsible
                handleTriggerClick={handleClick}
                accordionPosition={index}
                openedClassName="openFaq"
                open={index === currentOpened}
                trigger={term.question}
                easing="cubic-bezier(.67,.86,.68,1.19)"
                transitionTime={400}
              >
                <div
                  className="answer"
                  dangerouslySetInnerHTML={{
                    __html: sanitizeHtml(term.answer, sanitizeSettings),
                  }}
                />
              </Collapsible>
            </div>
          ))}
      </div>
    </FaqStyles>
  );
};

export default FaqComponent;
